import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { computed } from '@vue/composition-api';

import en from './locale/en';
import ja from './locale/ja';

const messages = {
  en,
  ja,
};

Vue.use(VueI18n);

export const languages: { [key: string]: string } = {
  en: 'English',
  ja: '日本語',
};

export const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages,
});

export const useI18n = (key: string) => computed(() => i18n.tc(key));
